import { Skeleton } from "@/shared/ui";

interface Props {
  tableOnly?: boolean;
}

export default function WarehousePageSkeleton({ tableOnly }: Props) {
  const tableContent = (
    <>
      <div className="flex flex-col">
        <div className="grid grid-cols-7 gap-4 pb-3 border-b surface-base-stroke">
          {Array.from({ length: 7 }).map(function renderHeadSkeleton(_, i) {
            return <Skeleton key={i} height={20} />;
          })}
        </div>
        {Array.from({ length: 6 }).map(function renderRowSkeleton(_, rowIndex) {
          return (
            <div key={rowIndex} className="grid grid-cols-7 gap-4 py-3 border-b surface-base-stroke">
              {Array.from({ length: 7 }).map(function renderCellSkeleton(_, colIndex) {
                return <Skeleton key={colIndex} height={20} />;
              })}
            </div>
          );
        })}
      </div>

      <div className="flex items-center justify-between mt-4">
        <Skeleton width={200} height={20} />
        <div className="flex items-center gap-2">
          <Skeleton width={32} height={32} />
          <Skeleton width={32} height={32} />
          <Skeleton width={32} height={32} />
        </div>
      </div>
    </>
  );

  if (tableOnly) {
    return tableContent;
  }

  return (
    <>
      <div className="grid grid-cols-2 gap-2 mb-4">
        {Array.from({ length: 2 }).map(function renderCardSkeleton(_, i) {
          return (
            <div key={i} className="surface-container-fill radius-3xl p-5 flex flex-col gap-3">
              <div className="flex justify-start items-center gap-2">
                <Skeleton width={32} height={32} className="radius-xs" />
                <Skeleton width={100} height={16} />
              </div>
              <div className="flex flex-col gap-1">
                <Skeleton width={80} height={28} />
                <Skeleton width={160} height={14} />
              </div>
            </div>
          );
        })}
      </div>

      <div className="radius-3xl surface-base-fill p-7">
        {tableContent}
      </div>
    </>
  );
}
